interface PackageDimensionValues {
  length?: number | null;
  width?: number | null;
  height?: number | null;
}

/** Filled once at least one of length, width, or height is above zero. */
export function isPackageDimensionsFilled({
  length,
  width,
  height,
}: PackageDimensionValues): boolean {
  return [length, width, height].some((dimension) => (dimension ?? 0) > 0);
}
